import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import { RefObject } from 'react'

interface DeleteOccupationDialogProps {
  isOpen: boolean
  leastDestructiveRef: RefObject<HTMLButtonElement>
  onClose: () => void
  onConfirm: () => void
}

export default function DeleteOccupationDialog({
  isOpen,
  leastDestructiveRef,
  onClose,
  onConfirm,
}: DeleteOccupationDialogProps) {
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={leastDestructiveRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete Occupation
          </AlertDialogHeader>
          <AlertDialogBody>
            Are you sure you want to delete this occupation? This action cannot
            be undone.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={leastDestructiveRef} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="red" onClick={onConfirm} ml={3}>
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export {}
